import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorEnum, getAPIErrorMessage } from '@nw/shared/utils';

import { GetFormReferralCodeResponseType } from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

const useGetFormReferralCode = (): {
  getFormReferralCodeApi: UseMutateAsyncFunction<
    GetFormReferralCodeResponseType,
    unknown,
    {
      formId: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
  isInvalidLicenceCodeCarryForwardConfigNotFoundError: boolean;
} => {
  const { formsServiceAPI } = useFormsService();

  const getFormReferralCode = ({ formId }: { formId: string }) => {
    return formsServiceAPI.getFormReferralCode({
      formId
    });
  };

  const { mutateAsync, error, status } = useMutation(getFormReferralCode, {
    mutationKey: ['getFormReferralCodeApi']
  });

  const getFormReferralCodeApi = mutateAsync;

  const isInvalidLicenceCodeCarryForwardConfigNotFoundError =
    error &&
    getAPIErrorEnum(error) ===
    'LICENCE_CODE_CARRY_FORWARD_CONFIG_IS_NOT_FOUND_FOR_FORM_ID';

  return {
    getFormReferralCodeApi,
    error: error ? getAPIErrorMessage(error) : '',
    status,
    isInvalidLicenceCodeCarryForwardConfigNotFoundError
  };
};

export { useGetFormReferralCode };
